import { createSelector, select } from '@ngrx/store';

import { StateSelector } from '@fcom/core/selectors/selector-utils';

import { CommonBookingFeatureState, CommonBookingState, PassengerNameRecord } from '../../store/store.interface';
import { selectCommonBookingState } from './feature.selector';

const _getRedirectPnrOrUndefined = createSelector(
  selectCommonBookingState,
  (state: CommonBookingState) => state?.redirect?.pnr
);

export const getRedirectPnrOrUndefined = (): StateSelector<
  CommonBookingFeatureState,
  PassengerNameRecord | undefined
> => select(_getRedirectPnrOrUndefined);
